import * as Website from '../Config/Website.js';

const HamMenu = {
  element: {
    naviFrame: '.js-naviFrame',
    button: '.js-hamButton',
    menuFrame: '.js-menuFrame',
    scrollLink: '.js-scroll',
  },
  init() {
    console.log('HamMenu init');
    const naviFrame = document.querySelector(this.element.naviFrame);
    const button = document.querySelector(this.element.button);
    const menuFrame = document.querySelector(this.element.menuFrame);
    if (!naviFrame || !button) return;
    this.toggle(naviFrame, button);
    if (menuFrame) this.closeOnNavClick(naviFrame, button);
  },
  toggle(naviFrame, button) {
    button.addEventListener('click', () => {
      naviFrame.classList.toggle('--active');
      button.classList.toggle('--open');
    });
  },
  scrollShow() {
    const menuFrame = document.querySelector(this.element.menuFrame);
    if (!menuFrame) return;
    if (Website.status.scrollY > 100) {
      menuFrame.classList.add('--visible');
    } else {
      menuFrame.classList.remove('--visible');
    }
  },
  closeOnNavClick(naviFrame, button) {
    const links = document.querySelectorAll(this.element.scrollLink);
    links.forEach(link => {
      link.addEventListener('click', () => {
        naviFrame.classList.remove('--active');
        button.classList.remove('--open');
      });
    });
  },
}

export default HamMenu;
